export enum AppState {
    START_PAGE      = 0,
    LOADING         = 1,
    SHOW_REPORT     = 2,
    ERROR           = 3
}

export enum ColumnType {
    ESTIMATE        = "Estimate",
    TIME_REPORTED   = "Time Reported",
    SPENT_ESTIMATE  = "Spent/Estimate",
}

export enum WorkItemReportTypeView {
    DAILY       = 'daily',
    WEEKLY      = 'weekly',
    MONTHLY     = 'monthly'
}
